import React from "react";
import Separator from "@components/ui/separator";
import styles from "../../Swap.module.scss";

interface FlipProps {
    handleFlip: () => void;
}

const Flip: React.FC<FlipProps> = ({ handleFlip }) => {
    return (
        <div className={"relative flex items-center"}>
            <button onClick={handleFlip} className={styles.change}>
                <img width={18} height={18} src="/images/swap/change.svg" alt="Change assets" />
            </button>
            <Separator />
        </div>
    );
};

export default Flip;
